<template>
  <div id="question">
    <van-list
      v-model="listLoading"
      :finished="finished"
      finished-text="没有更多数据了"
      @load="requestList"
      v-bind:callback="requestList"
    >
      <questionnaireListCard
        v-show="questionList.length !== 0"
        :incomingList="questionList"
      />
    </van-list>
  </div>
</template>

<script>

import questionnaireListCard from "@/pages/operationalAnalysis/components/MyquestionListCard.vue";

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      questionList: [],
      listLoading: false,
      finished: true,
      totalPages: 0 //总页数
    };
  },
  components: {
    questionnaireListCard
  },
  created: function() {
    this.requestList()
  },
  mounted: function() {},
  methods: {
    //请求数据
    async requestList() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/Questionnaire/GetForCurrUser"
      );
      this.xy.unloading();
      if (res && res.data) {
        for (let i = 0; i < res.data.length; i++) {
          // console.log(newVal);
          if (res.data[i].PublishStauts === 0) {
            res.data[i].PublishStauts = false;
          } else {
            res.data[i].PublishStauts = true;
          }
        }
        console.log(res.data)
        // this.totalPages = Math.ceil(res.data.totalRecords / this.pageSize); //总页数
        this.questionList = [...this.questionList,...res.data];
        // console.log(this.questionList, this.totalPages);
        /* 单次请求数据完毕 */
        this.listLoading = false;
        if (this.page >= this.totalPages) {
          /* 所有数据加载完毕 */
          this.finished = true;
          return;
        }
        this.page++;
      } else {
        this.questionList = [];
        this.listLoading = false;
        this.finished = true;
      }
    }
  }
};


</script>
<style lang='less' >